import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Alert, Button, Col, Form, FormGroup, Row } from "reactstrap";
import { Form as FinalForm, Field } from "react-final-form";
import LogoCompany from "../common/LogoCompany";
import TextInput from "../common/TextInput";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { combineValidators, isRequired } from "revalidate";
import { RootStoreContext } from "../../app/stores/rootStore";
import { FORM_ERROR } from "final-form";
import { IGuestPinFormValues} from "../../app/models/guest";
import GenericModal from "../common/GenericModal";
import GlobalGuestUploadForm from "../forms/GlobalGuestUploadForm";
import UploadedFileModal from "../modals/UploadedFileModal";
import { IResultUploadFilesDto } from "../../app/models/repositoryUser";
import GenericConfirmModal from "../common/GenericConfirmModal";
import "../../assets/scss/guest.scss";

interface IPresentationPin {
  isOpen: boolean,
  title: string,
  code: string,
  presentationId: number 
}

interface IParams {
  zone: string;
}

const validate = combineValidators({
  pin: isRequired("pin"),
});

const DocumentPinForm: React.FC<IParams> = ({ zone }) => {
  const rootStore = useContext(RootStoreContext);
  const { submitDocumentPin ,logout, loadPresentation, getInfoPresentation, redirectGuestScreen} = rootStore.guestStore;
  const { company } = rootStore.commonStore;
  const { errorsFilesUploaded } = rootStore.presentationStore;
  const [t] = useTranslation(["guest"], translationHookOptions);
  const [isModalPresentationOpen, setIsModalPresentationOpen] = useState(false);
  const [isModaluploadedOpen, setIsModaluploadedOpen] = useState<IPresentationPin>({isOpen: false, title: "", code: "", presentationId: 0});
  const [isModalErrorMessageOpen, setIsModalErrorMessageOpen] = useState(false);
  const [isModalLastUploadedOpen, setIsModalLastUploadedOpen] = useState<IPresentationPin>({isOpen: false, title: "", code: "", presentationId: 0});



  // useEffect(() => {
  //   let localStorageSavedString = localStorage.getItem('Presentation_Pin') ?? "";
  //   let pin = localStorageSavedString.split("_")[1];
  //   let presentationId = parseInt(localStorageSavedString.split("_")[0]);
  //     if (!pin || pin === "") {
  //       localStorage.setItem('Presentation_Pin', "");
  //     }else{
  //       console.log("pin", pin)
  //       submitDocumentPin({ pin: pin, zone: zone}, presentationId, true, false).then((presentation) => {
  //         if(presentation){ 
  //           setIsModalLastUploadedOpen({isOpen: true, title: presentation.presentationName, code: pin, presentationId: presentation.presentationId});
  //         }
  //       }).catch((error) => {
  //       });
  //     }
  // }, [submitDocumentPin, zone]);

  
  useEffect(() => {
    let localStorageSavedString = localStorage.getItem('Presentation_Pin') ?? "";
    let pin = localStorageSavedString.split("_")[1];
    let presentationId = parseInt(localStorageSavedString.split("_")[0]);
      if (!pin || pin === "") {
        localStorage.setItem('Presentation_Pin', "");
      }else{
        console.log("pin", pin)
        getInfoPresentation( presentationId , pin).then((presentation) => {
          if(presentation.presentationId > 0){ 
            // vuol dire che il Pin è ancora valido per cui apro la modale
            setIsModalLastUploadedOpen({isOpen: true, title: presentation.presentationName, code: pin, presentationId: presentation.presentationId});
          }
        }).catch((error) => {
        });
      }
  }, [getInfoPresentation, zone]);



  return (
    <>
      <div className="form-wrapper mt-0">
        <div>
          <LogoCompany className="loginLogo" />
        </div>
        <h5 className="mt-5 mb-1">
          {company?.isGlobalGuestFullyEnabled ? 
            <b>{t("globalGuest_message")}</b>
            :
            <b>{t("insert_document_pin")}</b>
          }
        </h5>
        <FinalForm
          initialValues={{
            zone: zone,
          }}
          onSubmit={(values: IGuestPinFormValues) =>
            submitDocumentPin(values).then((presentation) => {
              
              if(company?.isGlobalGuestFullyEnabled ){
                localStorage.setItem('Presentation_Pin', presentation?.presentationId + "_" + values.pin);
                loadPresentation();
              }
            }).catch((error) => ({
              [FORM_ERROR]: error,
            }))
          }
          validate={validate}
          render={({
            handleSubmit,
            submitting,
            submitError,
            invalid,
            pristine,
            dirtySinceLastSubmit,
          }) => (
            <Form onSubmit={handleSubmit} role="form">
              <FormGroup className="form-group input-group-lg">
                <Field
                  className="form-control"
                  name="pin"
                  component={TextInput}
                  placeholder={t("pin_placeholder")}
                  autoComplete="off"
                />
                <Field name="zone" component={TextInput} type="hidden" />
              </FormGroup>
              {submitError && !dirtySinceLastSubmit && (
                <Alert color="danger">{t("invalid_presentation_pin")}</Alert>
              )}
              <div className={"text-center " + company?.isGlobalGuestFullyEnabled ? "" : "mt-4"}>
                <Button
                  disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  className="btn loginButton btn-block btn-lg"
                  color="dark"
                  type="submit"
                >
                  {t("open")}
                </Button>
              </div>
            </Form>
          )}
        />
        {(company?.isGlobalGuestFullyEnabled || company?.isLoginWithUsernameEnabled) && (
          <>
            <div className="text-center text-muted mt-4 mb-2">
              <h6 className="linedText">
                <span className="linedSpan">
                  {t("login_method_separator", { ns: "translation" })}
                </span>
              </h6>
            </div>
            {company.isLoginWithUsernameEnabled && (
              <div className="text-center text-muted mb-4">
                <a className="text-muted text-underline" href="/">
                  <u>{t("email_login_link")}</u>
                </a>
              </div>
            )}
            {company.isGlobalGuestFullyEnabled && (
              <div className="text-center text-muted mb-4">
                <h5 className="mt-4 mb-1">
                  <b>{t("globalGuest_UploadMessage")}</b>
              </h5>
                <GlobalGuestUploadForm
                  parentNodeId={0}
                  onNodeSubmit={(dto : IResultUploadFilesDto) => {
                    if( dto.errorfiles && dto.errorfiles.length > 0){
                      setIsModalErrorMessageOpen(true);
                    } else {
                      setIsModaluploadedOpen({isOpen: true, title: dto.title, code: dto.code, presentationId: 0});
                    }
                    setIsModalPresentationOpen(!isModalPresentationOpen);
                  }}
                />
                <UploadedFileModal
                    toggle={() => setIsModalErrorMessageOpen(!isModalErrorMessageOpen)} 
                    errorfileUploaded={errorsFilesUploaded} isOpen={isModalErrorMessageOpen}            
                  />
                <GenericConfirmModal
                  toggle={() => setIsModaluploadedOpen({ isOpen: false, title: "", code: "", presentationId: 0 })}
                  isOpen={isModaluploadedOpen.isOpen}
                  showCancelButton={false}
                  title={t("globalGuest_UploadedModalTitle")}
                  // jsxMessage={
                  // <div>
                  //   <div style={{display:"flex"}}><p>{t("globalGuest_UploadedMessage1")}</p><p style={{fontWeight: "bold", marginLeft: "1%"}}>{"'" + isModaluploadedOpen.title + "'"}</p></div>
                  //   <div style={{display:"flex"}}><p>{t("globalGuest_UploadedMessage2")}</p><p style={{fontWeight: "bold", marginLeft: "1%"}}>{isModaluploadedOpen.code}</p></div>
                  // </div>
                  // }
                  jsxMessage={
                    <>  
                    <Row style={{marginTop:"2%"}}>
                      <Col>
                      {t("globalGuest_UploadedMessage1")} <b>{isModaluploadedOpen.title}</b>
                      </Col>

                    </Row>
                    <Row style={{marginTop:"2%"}}>
                      <Col>
                      {t("globalGuest_UploadedMessage2")} <b>{isModaluploadedOpen.code}</b>
                      </Col>

                    </Row>
                    </>
                    }
                  action={async () =>{
                    await submitDocumentPin({ pin: isModaluploadedOpen.code, zone: zone }).then(async (presentation) => {
                      localStorage.setItem('Presentation_Pin', presentation?.presentationId + "_" + isModaluploadedOpen.code);
                    })
                    await loadPresentation()
                  } }
                />
                <GenericModal
                  toggle={(successfullyCompleted) => {
                    setIsModalLastUploadedOpen((prev) => { return {...prev, isOpen: false}});
                    if(successfullyCompleted === false  || successfullyCompleted === undefined){
                      localStorage.setItem('Presentation_Pin', "");
                      const pathAfterGuest = window.location.href.split("/guest")[1]; // Ottiene tutto dopo "/guest"
                      redirectGuestScreen(pathAfterGuest);  
                   
                      }
                    }
                  }
                  isOpen={isModalLastUploadedOpen.isOpen}
                  title={t("globalGuest_LastUploadedModalTitle")} 
                  // content={
                  //   <>
                  //   <div style={{display:"flex",flexDirection: "column"}}>
                  //      <div style={{display: "flex", justifyContent: "space-between"}}><p>{t("globalGuest_LastUploadedMessage1")}</p><p style={{fontWeight: "bold", marginLeft: "1%", alignSelf: "end"}}>{"'" + isModalLastUploadedOpen.title + "'"}&nbsp;</p></div>
                  //      <div style={{display: "flex", justifyContent: "space-between"}}><p>{t("globalGuest_LastUploadedMessage2")}</p><p style={{fontWeight: "bold", marginLeft: "1%"}}>{isModalLastUploadedOpen.code}</p></div>
                  //  </div>
                  // </> 
                  // }
                  content={
                    <>
                    <Row>
                      <Col>
                      {t("globalGuest_LastUploadedMessage1")} 
                      </Col>

                    </Row>
                    <Row style={{marginTop:"2%"}}>
                      <Col>
                      {t("globalGuest_LastUploadedMessage3")} <b>{isModalLastUploadedOpen.title}</b>
                      </Col>

                    </Row>
                    <Row style={{marginTop:"2%"}}>
                      <Col>
                      {t("globalGuest_LastUploadedMessage2")} <b>{isModalLastUploadedOpen.code}</b>
                      </Col>

                    </Row>
                  </>
                  }
                  actions={[{
                    text: t("continue"),
                    action: async () => {
                    //   await loadPresentation().then(() => {
                    //     submitDocumentPin({ pin: isModalLastUploadedOpen.code, zone: zone }).then((presentation => {
                    //       localStorage.setItem('Presentation_Pin', presentation?.presentationId + "_" + isModalLastUploadedOpen.code);
                    //     }));
                    //     setIsModalLastUploadedOpen((prev) => { return {...prev, isOpen: false}});
                    //   }
                    // ).catch((error) => {
                    //   localStorage.setItem('Presentation_Pin', "");
                    //   });

                      await submitDocumentPin({ pin: isModalLastUploadedOpen.code, zone: zone }).then((presentation) => {
                        localStorage.setItem('Presentation_Pin', presentation?.presentationId + "_" + isModalLastUploadedOpen.code);
                     
                      })
                      await loadPresentation()
                      setIsModalLastUploadedOpen((prev) => { return {...prev, isOpen: false}});
                    },
                    color : "secondary"
                    },{
                      text: t("cancel"),
                      action: () => {
                        const pathAfterGuest = window.location.href.split("/guest")[1]; // Ottiene tutto dopo "/guest"
                        localStorage.setItem('Presentation_Pin', "");
                        redirectGuestScreen(pathAfterGuest);
                        setIsModalLastUploadedOpen((prev) => { return {...prev, isOpen: false}})
                      },
                      color : "secondary"
                      }]
                  }
                />
            </div>
            )}
          </>
        )}
      </div>
        
  </>
  );
};

export default observer(DocumentPinForm);
